import { GetVariants_trimLevelVariants_variants } from '../graphql/__generated__/GetVariants';
import { IVariant } from '../model/IVariants';
import stringUtilities from '../../../../common/utilities/stringUtilities';

const marketingCategoryService = {
  getUniquerMarketingCategories: (variants: GetVariants_trimLevelVariants_variants[]) => {
    return variants.reduce((acc, current) => {
      const marketingCategorySlug = stringUtilities.slugify(current.variant.attributes.marketingCategory ?? '');
      if (!acc.includes(marketingCategorySlug)) {
        return [...acc, marketingCategorySlug];
      }

      return acc;
    }, []);
  },
  getVariantsByMarketingCategory: (variants: IVariant[], marketingCategory: string) => {
    return variants?.reduce((acc, current) => {
      const variantMarketingCategory = stringUtilities.slugify(current.variant.attributes.marketingCategory);
      const currentMarketingCategory = stringUtilities.slugify(marketingCategory);
      if (variantMarketingCategory === currentMarketingCategory) {
        return [...acc, current];
      }

      return acc;
    }, []);
  },
};

export default marketingCategoryService;
